/** Tab-scoped session token. Legacy localStorage values are moved once, then removed. */

export function readAuthToken() {
  if (typeof window === 'undefined') {
    return null;
  }

  const sessionToken = window.sessionStorage.getItem('token');
  if (sessionToken) {
    window.localStorage.removeItem('token');
    return sessionToken;
  }

  const legacyToken = window.localStorage.getItem('token');
  if (legacyToken) {
    window.sessionStorage.setItem('token', legacyToken);
    window.localStorage.removeItem('token');
    return legacyToken;
  }

  return null;
}

export function storeAuthToken(token) {
  if (typeof window === 'undefined' || !token) {
    return;
  }
  window.sessionStorage.setItem('token', token);
  window.localStorage.removeItem('token');
}

export function clearStoredAuthToken() {
  if (typeof window === 'undefined') {
    return;
  }
  window.sessionStorage.removeItem('token');
  window.localStorage.removeItem('token');
}
